export default "__VITE_ASSET__VAJztXCG__"